import { initialModule, ModuleMetadata } from '../base/initial-module';

import { SpecServiceOptions } from './options';

/**
 * @internal
 */
export function initialServiceModule<S>(options: Required<SpecServiceOptions<S>>): ModuleMetadata {
  const moduleMetadata = initialModule(options);

  moduleMetadata.providers.push(options.service);

  return moduleMetadata;
}
